module.exports = __webpack_public_path__ + "img/SAA.0ca5b442.jpg";